module.exports = __webpack_public_path__ + "assets/img/1151587028246_.pic_hd.f8f77749.jpg";